import { useEffect, useState } from "react"
import { useFetch } from "../../../common/hooks/useFetch"
import debounce from "lodash.debounce"
import { listVariousDocumentAdminService } from "../services/listVariousDocumentAdmin.service"

export const useVariousDocumentAdminQuery = (filters) => {
  const fetchData = useFetch()
  const [documents, setDocuments] = useState([])
  const [loading, setLoading] = useState(false)
  const [total, setTotal] = useState(0)
  const [page, setPage] = useState(1)
  const [limit, setLimit] = useState(50)
  const [refresh, setRefresh] = useState(false)

  useEffect(() => {
    const fetchDocuments = async () => {
      try {
        setLoading(true)
        const response = await listVariousDocumentAdminService(fetchData)({ filters: { page, limit, ...filters } })
        setDocuments(response.data)
        setTotal(response.total)
      } catch (error) {
        console.error(error)
      } finally {
        setLoading(false)
      }
    }

    const debounced = debounce(fetchDocuments, 500)
    debounced()
    return () => debounced.cancel()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [page, limit, refresh, filters.startDate, filters.endDate, filters.description])

  return {
    documents,
    loading,
    total,
    page,
    limit,
    refresh: () => setRefresh(prev => !prev),
    onChangePage: (page) => setPage(page),
    onChangeLimit: (limit) => setLimit(limit)
  }
}
